<template>
  <v-dialog
      v-model="open"
      max-width="500px"
  >
    <v-card>
      <v-card-title>
        <span class="headline">{{ title }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row align="center">
            <v-col
                cols="12"
                sm="12"
            >
              <v-text-field
                  v-model="editedItem.name"
                  label="Affiliate Name"
              ></v-text-field>
            </v-col>
            <v-col
                cols="12"
                sm="12"
            >
              <v-text-field
                  v-model="editedItem.email"
                  label="Email"
              ></v-text-field>
            </v-col>
            <v-col
                cols="12"
                sm="12"
            >
              <v-select
                  v-model="editedItem.affiliateManagerId"
                  :items="$store.state.managers.affiliateManagers"
                  item-value="id"
                  item-text="name"
                  label="Affiliate Manager"
              ></v-select>
            </v-col>
            <v-col
                cols="12"
                sm="12"
            >
              <v-text-field
                  v-model="editedItem.postbackUrl"
                  label="Postback URL"
              ></v-text-field>
            </v-col>
            <v-col
                cols="12"
                lg="6"
            >
              <v-select
                  v-model="editedItem.currencyId"
                  :items="[{id: 1, name: '$'}, {id:2, name: '€'}, {id: 3, name: 'R$'}, {id: 4, name: '£'}]"
                  item-value="id"
                  item-text="name"
                  label="Currency"
              ></v-select>
            </v-col>
            <v-col
                cols="12"
                lg="6"
            >
              <v-select
                  v-model="editedItem.billingCycle"
                  :items="['weekly', 'monthly', 'semimonthly']"
                  label="Billing Cycle"
              ></v-select>
            </v-col>
            <v-col
                cols="12"
                lg="6"
            >
              <v-text-field
                  v-model="editedItem.paymentType"
                  label="Payment Type"
                  readonly
                  disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" lg="2">Status</v-col>
            <v-col
                cols="12"
                lg="4"
            >
              <v-select hide-details label="Status"
                        :items="statuses"
                        v-model="editedItem.status"
              ></v-select>

            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="secondary"
            text
            @click="close"
        >
          Cancel
        </v-btn>
        <v-btn
            color="primary"
            text
            @click="save"
        >
          Save
        </v-btn>
      </v-card-actions>
      <div class="loader-wrapper" v-if="loading">
        <v-progress-circular
            :size="50"
            color="primary"
            indeterminate
        ></v-progress-circular>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions} from "vuex";
import store from "@/store";

export default {
  name: 'EditProfile',
  props: {
    title: {
      type: String,
      default: 'New Profile'
    },
    dialog: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => ({})
    }
  },
  model: {
    prop: 'dialog',
    event: 'toggle'
  },
  data() {
    return {
      open: this.dialog,
      editedItem: {},
      loading: false,
      statuses: [
        {value: 'active', text: 'Active'}, {value: 'inactive', text: 'Inactive'},  {value: 'pending', text: 'Pending'},
        {value: 'rejected', text: 'Rejected'}, {value: 'suspended', text: 'Suspended'}, {value: 'blocked', text: 'Blocked'},  {value: 'blacklisted', text: 'Blacklisted'}
      ],
    }
  },
  watch: {
    open() {
      this.$emit('toggle', this.open);
    },
    dialog() {
      this.open = this.dialog
    },
    item() {
      this.editedItem = this.item || {};
    }
  },
  mounted() {
    this.editedItem = this.item || {};
  },
  methods: {
    ...mapActions('alert', ['ALERT_SUCCESS', 'ALERT_ERROR', 'ALERT_INFO', 'ALERT_WARNING', 'ALERT']),
    async save() {
      // call preloader
      this.loading = true;
      // call save profile store action
      try {
        await store.dispatch('affiliates/saveAffiliateProfile', this.editedItem)
        this.ALERT_SUCCESS('Saved 👍');
        setTimeout(() => {
          this.ALERT_SUCCESS('');
        }, 6000);
        this.open = false;
      } catch (err) {
        this.ALERT_ERROR(err.message);
      } finally {
        this.loading = false;
      }
      // hide preloader
      this.$emit('save', this.editedItem)
    },
    close() {
      this.editedItem = {}
      this.open = false;
    }
  }
}
</script>

<style lang="sass">
  .loader-wrapper
    position: absolute
    width: 100%
    height: 100%
    top: 0
    left: 0
    display: flex
    justify-content: center
    align-items: center
    background-color: rgba(255,255,255, 0.8)
  .edit-modal-switch
    .v-label
      margin-bottom: 0
      font-style: italic
      margin-left: 10px
</style>
